import { defineMessages } from 'react-intl';

export default defineMessages({
  fraudReasonBricking: {
    id: 'view.fraudReason.Bricking',
    defaultMessage: 'Bricking',
  },
  fraudReasonContentSubstitution: {
    id: 'view.fraudReason.ContentSubstitution',
    defaultMessage: 'Content Substitution',
  },
  fraudReasonDocumentFalsification: {
    id: 'view.fraudReason.DocumentFalsification',
    defaultMessage: 'Document Falsification',
  },
  fraudReasonCounterfeit: {
    id: 'view.fraudReason.Counterfeit',
    defaultMessage: 'Counterfeit',
  },
  fraudReasonWardrobing: {
    id: 'view.fraudReason.Wardrobing',
    defaultMessage: 'Wardrobing',
  },
  notSpecified: {
    id: 'view.fraudReason.notSpecified',
    defaultMessage: 'Not Specified',
  },
});
